export const API_PATHS = {
  THINKING_ASSISTANT: {
    CREATE_CONFERENCE: "thinkingassistant/conference",
    SEND_MESSAGE: "thinkingassistant/message"
  },
  USER: {
    CREATE: "thinkingassistant/user"
  },
  PUBLIC: {
    EVENTS: "public/events",
    HOST_INFO: "public/hosts/{handle}",
    HOST_EVENTS: "public/events/hosts/{handle}",
    WATERCOOLER_ACTIVITY: "public/watercooler/activity"
  },
  WATERCOOLER: {
    ENTER: "watercooler/enter",
    TOKEN: "watercooler/token",
    JOINED: "watercooler/joined",
    LEAVE: "watercooler/leave",
    ACTIVITY: "watercooler/activity",
    TAGLINE: "watercooler/tagline",
    TRACK: "watercooler/track",
    VENUE_CONFIG: "watercooler/venue-config",
    VISIT_MEMORY: "watercooler/visit-memory",
    STUDIO_TOKEN: "watercooler/studio-token",
    // Subscribe and unsubscribe share one path (action in the body): the API
    // Gateway is explicit-per-path, so every extra route is manual GW surgery.
    PUSH: "watercooler/push"
  },
  STRIPE: {
    CHECK_STRIPE_ACCOUNT: 'users/stripe-account',
    CREATE_CONNECT_ACCOUNT: 'users/stripe-connect-onboarding',
    CHECK_ACCOUNT_STATUS: 'users/stripe-connect/account-status/{accountId}',
  },
  // Subscription pricing (new flow, gated by tier pricing_mode='subscription')
  SUBSCRIPTIONS: {
    PLANS: 'subscriptions/{eventId}/plans',
    CHECKOUT: 'subscriptions/{eventId}/{invitationCode}/checkout',
    VERIFY: 'subscriptions/{eventId}/verify',
    MY_SUBSCRIPTION: 'subscriptions/{eventId}/my-subscription',
    CANCEL_RENEWAL: 'subscriptions/{eventId}/cancel-renewal',
    RESUME_RENEWAL: 'subscriptions/{eventId}/resume-renewal',
    PORTAL: 'subscriptions/portal',
  },
  USERS: {
    PRICING_TIERS_DEFAULTS: 'users/pricing-tiers-defaults',
    PRICING_TIERS: 'users/pricing-tiers',
    PROFILE: "users/profile",
  },
  FEEDBACK: {
    CREATE: "feedback/",
  },
  LLM_CALLS: {
    BEAUTIFY: "llmcalls/beautify/",
  },
  EVENTS: {
    BASE: "events/",//not used
    CREATE: "events/",
    DETAILS: "events/{eventId}",
    REGISTER: "events/{eventId}/{invitation_code}/register",
    UPDATE: "events/{eventId}/update",
    TIER_STATUS: "events/{eventId}/tier-status",
    MY_MATCHING_INFO: "events/{eventId}/my-matching-info",
    MATCHES: "events/{eventId}/matches",
    REGISTERD_EVENTS: "events/registered-events",
    PUBLISHED: "events/published-events"
  },
  TECHWEEK: {
    // Rides the /subscriptions/{proxy+} gateway resource — zero API GW wiring.
    META: "subscriptions/techweek/meta",
    EVENTS: "subscriptions/techweek/events",
    PLAN: "subscriptions/techweek/plan",
    PROFILE: "subscriptions/techweek/profile",
  },
  ORANGE: {
    CATALOG: "orange/catalog",
    GAMES: "orange/games",
    LIBRARY: "orange/library",
    WALLET: "orange/wallet",
    CHECKOUT: "orange/checkout",
    ASKS: "orange/asks",
    LEND: "orange/lend",
    USERS: "orange/users",
    DOWNLOAD: "orange/download",
  },
  ADVENTURE: {
    CAMPAIGNS: "adventure/campaigns",
    MY_CAMPAIGN: "adventure/campaigns/mine",
    MEDIA_IMAGE: "adventure/campaigns/{cid}/media/image",
    SCENE: "adventure/campaigns/{cid}/scene",
    TOOL: "adventure/campaigns/{cid}/tool",
    ROLLS: "adventure/campaigns/{cid}/rolls",
    MOVE: "adventure/campaigns/{cid}/encounters/{eid}/move",
    ACTIVE_PC: "adventure/campaigns/{cid}/active-pc",
    JOURNAL: "adventure/campaigns/{cid}/journal",
    REF_SPELLS: "adventure/reference/spells",
    REF_WEAPONS: "adventure/reference/weapons",
    HEALTH: "adventure/health",
    NAV_PLAN: "adventure/campaigns/{cid}/nav/plan",
    NAV_RING: "adventure/campaigns/{cid}/nav/ring",
    NAV_BUILD: "adventure/campaigns/{cid}/nav/build",
    WHY: "adventure/campaigns/{cid}/why",
    SPOKEN: "adventure/campaigns/{cid}/spoken",
    JOURNEY_PLAN: "adventure/campaigns/{cid}/journey/plan",
    JOURNEY_COMMIT: "adventure/campaigns/{cid}/journey/commit",
    JOURNEY_HALT: "adventure/campaigns/{cid}/journey/halt",
    CITY_MOVE: "adventure/campaigns/{cid}/journey/city-move",
    LEAVE_TOWN: "adventure/campaigns/{cid}/journey/leave-town",
    STEP_OUTSIDE: "adventure/campaigns/{cid}/journey/step-outside",
    MAP_ACTIVATE: "adventure/campaigns/{cid}/maps/{mid}/activate",
    CAMP_MARKERS: "adventure/campaigns/{cid}/camp/markers",
    ARCHIVE: "adventure/campaigns/{cid}/archive",
    UNARCHIVE: "adventure/campaigns/{cid}/unarchive",
    CAMPAIGN: "adventure/campaigns/{cid}",
    PORTRAIT: "adventure/campaigns/{cid}/characters/{chid}/portrait",
    PORTRAITS: "adventure/campaigns/{cid}/characters/{chid}/portraits",
    PORTRAIT_MEDIA: "adventure/campaigns/{cid}/portrait-images/{img}/media",
    PORTRAIT_ACTIVATE: "adventure/campaigns/{cid}/portrait-images/{img}/activate",
    CHARACTER: "adventure/campaigns/{cid}/characters/{chid}",
    DM_SETTINGS: "adventure/campaigns/{cid}/dm-settings",
    STORY: "adventure/story/{key}",
    SHOP: "adventure/campaigns/{cid}/shop",
    CUES: "adventure/campaigns/{cid}/cues",
    CUE: "adventure/campaigns/{cid}/cues/{cue_id}",
    BATTLEMAP: "adventure/campaigns/{cid}/maps/{mid}/battlemap",
    BATTLEMAP_REVIEW: "adventure/campaigns/{cid}/maps/{mid}/battlemap/review",
    // Round 17: a token is a person, and clicking it asks about that person.
    OCCUPANT_FACE: "adventure/campaigns/{cid}/maps/{mid}/occupants/{okey}/face",
    OCCUPANT_PORTRAIT: "adventure/campaigns/{cid}/maps/{mid}/occupants/{okey}/portrait",
    TAKE_STAIRS: "adventure/campaigns/{cid}/journey/take-stairs",
  },
};
